import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotesService {

  constructor(private http: HttpClient) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      // this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getNotes(agreementId: any, agreementYear: string ) {
    let param = new HttpParams();
    let url = '';
    if (agreementYear !== null) {
      param = param.append('agreementYear', agreementYear);
    }
    url = environment.serviceURL + environment.getNotes + agreementId;
    return this.http.get<any>(url, { params: param });
  }

  saveNotes(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.saveNotes, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  deleteNotes(deleteNotesId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: deleteNotesId
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteNotes, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete note')));
  }
}
